import React from "react";

const HomeButton = (props) => {

    const   [hover, setHover] = React.useState(false);

    const btnStyle = {
        backgroundColor: "blue",
        padding: "0.5rem",
        background: "linear-gradient(180deg, rgba(208, 241, 255, 0.67) -34.62%, rgba(208, 241, 255, 0.13) 136.54%)",
        backdropFilter: "blur(10px)",
        border: "1.5px solid #FFFFFF",
        borderRadius: "15px 0 15px 0",
        marginTop: "0.5rem",
        opacity: hover ? "1" : "0.8",
    }
    const borderStyle = {
        border: "3px solid #D0F1FF", 
        padding: ".5rem 3.5rem", 
        color: "#D0F1FF", 
        fontSize: "1.2rem",
        borderRadius: "15px 0 15px 0",
        cursor: "pointer"
    }

    return (
        <div>
            <button style={ btnStyle }
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <div style={ borderStyle }>{ props.text }</div>
            </button>
        </div>
    );
}

export default HomeButton;